import PropTypes from 'prop-types'
import {
  Heading,
  Wrapper,
  DefaultOption,
  SubHeading,
  Option as OptionWrapper
} from './styles'
import ProductInfoCard from '#src/common/components/product-info-card'
import CustomisationOption from '#src/products/product-details-page/components/food-customisation-group/customisation-option'
import { customisationGroup, image } from '#src/common/propTypes'
import Select from './customisation-option/select'

const FoodCustomisationGroup = ({
  customisation,
  placeholderImage,
  onCustomisationsChange
}) => {
  const { type, options, localisedLabel, multiSelectable, subHeading } =
    customisation

  const onChange = (checked, sku) => {
    const updatedCustomisation = {
      ...customisation,
      options: customisation.options.map(option => {
        return {
          ...option,
          isSelected:
            option.sku === sku
              ? checked
              : multiSelectable
              ? option.isSelected
              : false
        }
      })
    }
    onCustomisationsChange(updatedCustomisation)
  }

  return (
    <Wrapper>
      <Heading level='h2' styleOverride='headingXs'>
        {localisedLabel}
      </Heading>
      {subHeading && <SubHeading>{subHeading}</SubHeading>}
      {options.map(option => (
        <OptionWrapper
          key={`${type}-${option.sku}`}
          isDefault={option.isDefault}
        >
          {option.isDefault ? (
            <DefaultOption>
              <Select
                type={type}
                isSelected={option.isSelected}
                sku={option.sku}
                onChange={onChange}
                name={option.name}
                multiSelectable={multiSelectable}
                label={option.label}
              />
            </DefaultOption>
          ) : (
            <ProductInfoCard
              ingredientsId={option.sku}
              ingredients={option.ingredients}
              name={option.name}
              allergens={option.allergens}
            >
              <CustomisationOption
                multiSelectable={multiSelectable}
                productOption={option}
                placeholderImage={placeholderImage}
                onChange={onChange}
                type={type}
              />
            </ProductInfoCard>
          )}
        </OptionWrapper>
      ))}
    </Wrapper>
  )
}

FoodCustomisationGroup.propTypes = {
  customisation: customisationGroup.isRequired,
  placeholderImage: image.isRequired,
  onCustomisationsChange: PropTypes.func.isRequired
}

export default FoodCustomisationGroup
